module.exports = __webpack_public_path__ + "static/media/Menelaus.5ab7adae.jpg";